export const Spinner = (size) => {
  return (
    <div
      className="tw-inline-block tw-h-14 tw-w-14 tw-animate-spin tw-rounded-full tw-border-2 tw-border-solid tw-border-current tw-border-r-transparent tw-align-[-0.125em] motion-reduce:tw-animate-[spin_1.5s_linear_infinite]"
      role="status"
    />
  );
};
